import React from 'react'
import { MDBCol, MDBMask, MDBView } from 'mdbreact'
import { Link } from 'react-router-dom'
import ProgressiveImage from 'react-progressive-image'

const BlogCategory = ({categoryData}) => {
    const categories = categoryData.map((category)=>
        <>
        <MDBCol key={category.id} className="mt-4 mb-4" md="4" sm="12"> 
            <Link className="black-text text-lowercase" to={`/blogs/${category.category}`}>
                <div style={{ cursor: 'pointer' }} className="product-container">
                    <div className="product-img">
                        <MDBView zoom style={{ cursor: 'pointer' }}>
                        <ProgressiveImage src={category.image.url} placeholder={category.image.formats.thumbnail.url}>
                        {(src, loading) => (
                            <img 
                            style={{ filter: loading && "blur(10px)" }}
                            className="w-100"
                            src={src}
                            alt=""/>
                        )}
                        </ProgressiveImage>
                        <MDBMask style={{ cursor: 'pointer' }} className="flex-center" overlay="black-light">
                            <div className="product-desc h5-responsive text-uppercase text-center white-text font-weight-bold">
                                <span style={{ letterSpacing: '0.5rem' }}>{category.category}</span>
                            </div>
                        </MDBMask>
                        </MDBView>
                    </div>
                </div>
            </Link>
        </MDBCol>  
        </>
    )
    return (
        <>
        {categories}
        </>
    )
}

export default BlogCategory
